// What makes a task row valid. Dual-runtime, which is the whole reason it is
// here rather than in src/utilities/Validators.mjs where it started.
//
// The browser holds an invalid edit (useAutosave's `validate` contract: an
// inline field error, nothing enqueued). TaskPogoShareTasksWrite applies the
// same rule to a visitor's edit arriving over a public Function URL -- and it
// has to be the SAME rule, or a public writer could store a row the owner's own
// form calls invalid and the owner would then be unable to save the page it is
// on. groupPhotosByEntry's precedent: the module moves, and the old home
// re-exports so no caller changes.
//
// Contract: (state) => { ok: true } | { ok: false, fieldErrors: { key: message } }

import { trimmedStringOrNull } from './Common.mjs';

// Tasks: name required, and a counter-based due value needs to know which
// counter it's based on (mirrors both throws in Database.updateTask).
export function validateTask(state) {
  const fieldErrors = {};
  if (trimmedStringOrNull(state ? state.name : null) == null) {
    fieldErrors.name = 'Name is required.';
  }
  if (
    state &&
    state.dueCounter != null &&
    (state.itemCounterId == null || String(state.itemCounterId).length === 0)
  ) {
    fieldErrors.dueCounter = 'Fill in "Counter Based On" to use a counter due value.';
  }
  return Object.keys(fieldErrors).length > 0 ? { ok: false, fieldErrors } : { ok: true };
}

export default validateTask;
